export const INVALID_EMAIL = "Invalid email";
export const INVALID_PASSPORT = "Invalid passport";
export const INVALID_AADHAAR = "Invalid aadhar";
export const INVALID_PHONE = "Invalid Phone Number";
export const REQUIRED_FIELD_GREATERTHAN_0 = "Must Be Greater than 0";
export const REQUIRED_FIELD = "Required";
export const MIN_LENGTH_PWD =
  "Password is too short - should be 6 chars minimum.";
export const SUCCESS = "Success";
export const INVALID = "Invalid";
